// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comment-cls1__ce5130a86cc05f081edb{/*!*/}.Comment-cls2__a1b11e0edb23e09d7567{padding-top:5px;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comment-cls1__ce5130a86cc05f081edb",
	"cls2": "Comment-cls2__a1b11e0edb23e09d7567 Comment-cls1__ce5130a86cc05f081edb"
};
export default ___CSS_LOADER_EXPORT___;
